import { Injectable } from '@angular/core';
import { from, lastValueFrom } from 'rxjs';

@Injectable()
export class IndexedDbService {
    private dbName = 'Documalis';
    public version = 0;
    private tableList = [];
    public variableStorage: any;
    public groupVariable: any;

    constructor() {
        this.initialize();
    }

    public initialize() {
        this.tableList = [];
    }

    public getAllTablesInDatabase() {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName);
            request.onsuccess = function(event) {
                const db = request.result;
                const objectStoreNames = db.objectStoreNames;
                const tableList = Array.from(objectStoreNames);
                resolve(tableList);
            };
            request.onerror = (event) => {
                reject('Error opening database');
                console.error('Error opening database', request.error);
            };
        });
    }

    private addToDatabase(db, storeName, data) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([storeName], 'readwrite');
            const store = transaction.objectStore(storeName);
            data.forEach(item => {
                const request = store.add(item);
                request.onsuccess = function(event) {
                };
                request.onerror = function(event) {
                    reject('Error adding data');
                    console.error('Error adding data', request.error);
                };
            });
            transaction.oncomplete = function() {
                resolve('Data added successfully');
            };
        });
    }

    public async updateDataIndexedDb(aTableName, aKey, aData) {       
        let db: any;
        try {
            try {
                db = await this.openDatabase(aTableName);
                await this.updateDatabase(db, aTableName, aData, aKey);
                return true;
            } finally {
                if (db) {
                    db.close();
                }
            }            
        } catch (error) {
            console.log('updateDataIndexedDb error', error);
            return false;
        }
    }

    private updateDatabase(db, storeName, dataValue, key) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([storeName], 'readwrite');
            const store = transaction.objectStore(storeName);
            const getRequest = store.get(key);

            getRequest.onsuccess = function(event) {
                // Mettre à jour les données de l'enregistrement
                const data = getRequest.result;
                data.value = dataValue;
            
                // Utiliser la méthode put pour mettre à jour l'enregistrement
                const updateRequest = store.put(data);
            
                updateRequest.onsuccess = function(event) {
                };
            
                updateRequest.onerror = function(event) {
                  console.error('Error updating data');
                };
              };
            transaction.oncomplete = function() {
                resolve('Data updated successfully');
            };
        });
    }


    private getVersion(storeName) {
        let wDbversion: any;
        wDbversion = localStorage.getItem('databaseversion');
        if (wDbversion !== 'null' && wDbversion !== null) {
            this.version = wDbversion;
        } else {
            if (this.tableList.indexOf(storeName) === -1) {
                this.tableList.push(storeName);
                this.version++;
            }
        }
    }

    private openDatabase(storeName) {
        this.getVersion(storeName);
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.version);
      
            request.onupgradeneeded = function(event) {
                const db = request.result;
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName, { keyPath: 'id' });
                }
            };
            request.onsuccess = function(event) {
                resolve(request.result);
            };
            request.onerror = function(event) {
                reject('Error opening database');
                console.error('Error opening database', request.error);
            };
        });
    }

    public async storeBasketdb(aBskList, aBbskListUser, aBskListGroup) { 
        let wRes: any;
        let wBskList = [...aBskList, ...aBbskListUser, ...aBskListGroup];
        wRes = await this.addDataIndexedDb('bskList', wBskList);       
        return wRes;
    } 
    
    public async addDataIndexedDb(aTableName, aData) {
        let db: any;
        try {
            try {
                db = await this.openDatabase(aTableName);
                await this.addToDatabase(db, aTableName, aData);
                return true;
            } finally {
                if (db) {
                    db.close();
                }
            }            
        } catch (error) {
            console.log('addDataIndexedDb error', error);
            return false;
        }
    }

    public async getAllDatabase(db, storeName) {
        let wRes = [];
        let request: any;
        try {
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([storeName], 'readonly');
                const store = transaction.objectStore(storeName);
                request = store.getAll();
                request.onsuccess = function(event) {
                    request.result.forEach((element) => {
                        wRes[element.id] = element.value;        
                    })
                };
                request.onerror = function(event) {
                    reject('Error adding data');
                    console.error('Error readding data', request.error);
                };
                transaction.oncomplete = function() {
                    resolve(wRes);
                };
            });
            
        } catch (error) {
            console.log('getAllDatabase error');
        }    
        return wRes;
    }

    private async getDatabase(db, storeName, aKeys = null) {
        let wRes = [];
        try {
            return new Promise((resolve, reject) => {
                const transaction = db.transaction([storeName], 'readonly');
                const store = transaction.objectStore(storeName);
                var promises = [];
    
                aKeys.forEach(function(key) {
                  var promise = new Promise(function(resolve, reject) {
                    var getRequest = store.get(key);          
                    getRequest.onsuccess = function(event) {
                        wRes[key] = event.target.result.value;
                        resolve(wRes[key]);
                    };
              
                    getRequest.onerror = function(event) {
                      reject("Error readding key " + key);
                    };
                  });
                  promises.push(promise);
                });
              
                Promise.all(promises)
                  .then((results) => {
                    transaction.complete;
                    resolve(wRes);
                  })
                  .catch(function(error) {
                    console.log(error);
                    transaction.complete;
                    reject('getDatabase error');
                  });
            });        
        } catch (error) {
            console.log('getDatabase error');
        }    
        return wRes;
    }

    public async getBasketListByUser(): Promise<any> {
        let getBasketList: any = {};
        let wBasketList: any = {};
        let db: any;
        try {
            try {
                db = await this.openDatabase('bskList');
                wBasketList = await lastValueFrom(from(this.getDatabase(db, 'bskList', ['BasketMailList', 'BasketCollectList', 'BasketPublishList', 'BasketInputList'])));
                getBasketList = {
                    data: {
                        BasketMailList: wBasketList['BasketMailList'],
                        BasketCollectList: wBasketList['BasketCollectList'],
                        BasketPublishList: wBasketList['BasketPublishList'],
                        BasketInputList: wBasketList['BasketInputList'],
                    },
                };
                getBasketList.Status = 'OK';
            } finally {
                if (db) {
                    db.close();
                }
            }
        } catch (error) {
            console.log('execGetBasketList error', error);
            getBasketList.Status = 'ERROR'; 
        }
        return getBasketList;
    }

    public async getBasketList(): Promise<any> {
        let wBasketList: any = {};
        let db: any;
        try {
            try {
                db = await this.openDatabase('bskList');
                wBasketList = await lastValueFrom(from(this.getAllDatabase(db, 'bskList')));
                wBasketList.Status = 'OK';
            } finally {
                if (db) {
                    db.close();
                }
            }                    
        } catch (error) {
            console.log('getBasketList error', error);           
            wBasketList.Status = 'ERROR'; 
        }
        return wBasketList;
    }

    public async getVariables() {
        let wVariables: any = {};
        let db: any;
        try {
            try {
                this.variableStorage = [];
                db = await this.openDatabase('variables');
                wVariables = await lastValueFrom(from(this.getAllDatabase(db, 'variables')));
                if (wVariables) {
                    this.variableStorage = wVariables.variables;
                }
            } finally {
                if (db) {
                    db.close();
                }
            }                    
        } catch (error) {
            console.log('getVariables error', error);           
        }
    }

    public async getGroupVariables() {
        let wVariables: any = {};
        let db: any;
        try {
            try {
                this.groupVariable = [];
                db = await this.openDatabase('groupvariable');
                wVariables = await lastValueFrom(from(this.getAllDatabase(db, 'groupvariable')));
                if (wVariables) {
                    this.groupVariable = wVariables.groupvariable;
                }
            } finally {
                if (db) {
                    db.close();
                }
            }                    
        } catch (error) {
            console.log('getGroupVariables error', error);           
        }
    }
}
